import {inject, Injectable} from '@angular/core';
import {
  AttachProductCard,
  CreateProductCard,
  ProductCard
} from "../types/product-card.types";
import {ProductCardModalApiService} from "./product-card-modal-api.service";
import {ProductCardsRequestQueryParamsStateService} from "./product-cards-request-query-params-state.service";

@Injectable({
  providedIn: 'root'
})
export class ProductCardModalService {
  private productCardModalApiService: ProductCardModalApiService = inject(ProductCardModalApiService);
  private productCardsRequestQueryParamsStateService: ProductCardsRequestQueryParamsStateService = inject(ProductCardsRequestQueryParamsStateService);

  public getProductCards(): Promise<Array<ProductCard>> {
    return new Promise((resolve, reject) => {
      this.productCardModalApiService.getProductCards(this.productCardsRequestQueryParamsStateService.productCardsRequestQueryParams()).subscribe({
        next: (productCards: Array<ProductCard>) => resolve(productCards),
        error: (error) => reject(error)
      });
    });
  }

  public createProductCard(productCard: CreateProductCard): Promise<ProductCard> {
    return new Promise((resolve, reject) => {
      this.productCardModalApiService.createProductCard(productCard).subscribe({
        next: (productCards: ProductCard) => resolve(productCards),
        error: (error) => reject(error)
      });
    });
  }

  public attachProductCard(attachProductCard: AttachProductCard): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardModalApiService.attachProductCard(attachProductCard).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
